import * as types from "./types.js"
import * as api from "./api.js"


function getVisasRequest() {
    return {
        type: types.GET_VISAS_REQUEST
    }
}

function getVisasReceived(visas) {
    return {
        type: types.GET_VISAS_RECEIVED,
        payload: visas
    }
}

function getVisasError(e) {
    return {
        type: types.GET_VISAS_ERROR,
        payload: e,
        error: true
    }
}

export function getVisas(personid) {
    return dispatch => {
        dispatch(getVisasRequest())
        return api.getVisas(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getVisasError(res.statusText))
            } else {
                return res.json()
                .then(visas => {
                    dispatch(getVisasReceived(visas))
                })
            }
        })
    }
}


function postVisaRequest() {
    return {
        type: types.POST_VISA_REQUEST
    }
}

function postVisaReceived(visa) {
    return {
        type: types.POST_VISA_RECEIVED,
        payload: visa
    }
}

function postVisaError(e) {
    return {
        type: types.POST_VISA_ERROR,
        payload: e,
        error: true
    }
}

export function postVisa(visa) {
    return dispatch => {
        dispatch(postVisaRequest())
        return api.postVisa(visa)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postVisaError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postVisaReceived({
                        id: stats.id,
                        visa: visa.visa,
                        text: visa.text,
                        valid: visa.valid
                    }))
                })
            }
        })
    }
}


function putVisaRequest() {
    return {
        type: types.PUT_VISA_REQUEST
    }
}

function putVisaReceived(visa) {
    return {
        type: types.PUT_VISA_RECEIVED,
        payload: visa
    }
}

function putVisaError(e) {
    return {
        type: types.PUT_VISA_ERROR,
        payload: e,
        error: true
    }
}

export function putVisa(visa) {
    return dispatch => {
        dispatch(putVisaRequest())
        return api.putVisa(visa)
        .then(res => {
            if (res.status !== 200) {
                dispatch(putVisaError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(putVisaReceived({
                        id: visa.id,
                        visa: visa.visa,
                        text: visa.text,
                        valid: visa.valid
                    }))
                })
            }
        })
    }
}


function deleteVisaRequest() {
    return {
        type: types.DELETE_VISA_REQUEST
    }
}

function deleteVisaReceived(visa) {
    return {
        type: types.DELETE_VISA_RECEIVED,
        payload: visa
    }
}

function deleteVisaError(e) {
    return {
        type: types.DELETE_VISA_ERROR,
        payload: e,
        error: true
    }
}

export function deleteVisa(id) {
    return dispatch => {
        dispatch(deleteVisaRequest())
        return api.deleteVisa(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteVisaError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteVisaReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/visas/actions.js
 **/